import React from 'react'

export default function Debug({ data }: { data: any }): JSX.Element {
  return <pre>{JSON.stringify({ data }, null, 2)}</pre>
}
